import styled from 'styled-components';

const HelpBox = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${props => props.theme.global.colors.background};
    box-sizing: border-box;
    flex-direction: column;
    border-bottom: 1px solid ${props => props.theme.global.colors.border};
    color: ${props => props.theme.callouts.colors.helptext};
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 12px;
    padding: 0 10%;
    pointer-events: none;
    user-select: none;
    transition: all 400ms ease-in-out;
`;

const HelpClose = styled.div`
    position: absolute;
    font-size: 18px;
    color: ${props => props.theme.callouts.colors.helpicons};
    padding: 5px;
    top: 8px;
    right: 8px;
    transition: all 400ms ease-in-out;

    &:hover {
    transform: scale(1.2);
    }
`;

const HelpBody = styled.div`
    text-align: left;
    width: 100%;
`;

const HelpTitle = styled(HelpBody)`
    font-weight: bold;
    font-size: 14px;
    color: ${props => props.theme.callouts.colors.helptitle};
`;

const HelpIcon = styled(HelpClose)`
`;

export {
    HelpBox,
    HelpClose,
    HelpBody,
    HelpTitle,
    HelpIcon,
};



// WEBPACK FOOTER //
// ./src/components/atoms/callout/Help.js